<script lang="ts">
import i3pSubComponent from '@nuxtDatakodeUtils/components/i3p/I3pSubComponent.vue'
import { BaseRoutesEnum } from '~/enum/BaseRoutes.enum'

export default {
    name: 'TopButtons',
    extends: i3pSubComponent,
    props: {},
    data() {
        return {
        }
    },
    computed: {
        BaseRoutesEnum() {
            return BaseRoutesEnum
        },
    },
    mounted() {

    },
    methods: {
    },
}
</script>

<template>
    <v-btn
        v-if="baseUrl !== BaseRoutesEnum.myOpportunities"
        class="mr-2" variant="outlined" prepend-icon="mdi-format-list-bulleted-square" size="small" color="primary"
        :href="BaseRoutesEnum.myOpportunities" @click.prevent="$router.push(BaseRoutesEnum.myOpportunities)"
    >
        Voir mes opportunités
    </v-btn>
    <v-btn
        v-if="baseUrl !== BaseRoutesEnum.allOpportunities"
        class="mr-2" variant="outlined" prepend-icon="mdi-format-list-bulleted-square" size="small" color="primary"
        :href="BaseRoutesEnum.allOpportunities" @click.prevent="$router.push(BaseRoutesEnum.allOpportunities)"
    >
        Voir toutes les opportunités
    </v-btn>
</template>
